import TutorManager from "../managers/TutorManager";
import CourseManager from "../managers/CourseManager";
import OccasionManager from "../managers/OccasionManager";
import SubjectManager from "../managers/SubjectManager";
import TimetableManager from "../managers/TimetableManager";
import ClassroomManager from "../managers/ClassroomManager";
import DateManager from "../managers/DateManager";
export default class Manager {
    constructor(data) {
        this._tutorManager = new TutorManager(data.tutor);
        this._timetableManager = new TimetableManager(data.timetable);
        this._subjectManager = new SubjectManager(data.subject);
        this._courseManager = new CourseManager(data.course, this._subjectManager, this._timetableManager, this._tutorManager);
        this._occasionManager = new OccasionManager(data.occasion, this._courseManager);
        this._classroomManager = new ClassroomManager(this._occasionManager);
        this._dateManager = new DateManager(localStorage.getItem("start"));
    }
    get tutorManager() {
        return this._tutorManager;
    }
    set tutorManager(value) {
        this._tutorManager = value;
    }
    get courseManager() {
        return this._courseManager;
    }
    set courseManager(value) {
        this._courseManager = value;
    }
    get occasionManager() {
        return this._occasionManager;
    }
    set occasionManager(value) {
        this._occasionManager = value;
    }
    get subjectManager() {
        return this._subjectManager;
    }
    set subjectManager(value) {
        this._subjectManager = value;
    }
    get timetableManager() {
        return this._timetableManager;
    }
    set timetableManager(value) {
        this._timetableManager = value;
    }
    get classroomManager() {
        return this._classroomManager;
    }
    set classroomManager(value) {
        this._classroomManager = value;
    }
    get dateManager() {
        return this._dateManager;
    }
    set dateManager(value) {
        this._dateManager = value;
    }
}
